module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Bold.8b1926bb.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GT-Walsheim-Bold.eot
// module id = 645
// module chunks = 0